'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const Guid=require('pulsar-utils/dist-es6/domain/guid');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');

const SecretGuid=Guid.create().toString();
const SecretEmptyKey=`%%[[$$empty${SecretGuid}empty$$]]%%`;let

MultiValueAutocompleteDirective=function(_BaseControllerBacked){_inherits(MultiValueAutocompleteDirective,_BaseControllerBacked);function MultiValueAutocompleteDirective(){_classCallCheck(this,MultiValueAutocompleteDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(MultiValueAutocompleteDirective,[{key:'templateUrl',get:function()
{return'/templates/directives/multiValueAutocompleteDirective/multiValueAutocompleteTemplate'}},{key:'objectBindings',get:function()

{return['items','selectedItems','itemFormatter','autocompleteFilter']}},{key:'$inject',get:function()

{return['$scope','$element','$timeout']}},{key:'controller',get:function()

{return MultiValueAutocompleteController}}]);return MultiValueAutocompleteDirective}(BaseControllerBackedDirective);let


MultiValueAutocompleteController=function(){
function MultiValueAutocompleteController($scope,$element,$timeout){var _this2=this;_classCallCheck(this,MultiValueAutocompleteController);
if(!_.exists(this.items)||!Array.isArray(this.items)||this.items.length<1){
throw new Error('controller.items must be an array containing at least one value to use autocomplete directive.');
}else if(!_.exists(this.selectedItems)||!Array.isArray(this.selectedItems)){
throw new Error('controller.selectedItems must be an array to use autocomplete directive.');
}else if(!_.exists(this.itemFormatter)||typeof this.itemFormatter!='function'){
throw new Error('controller.itemFormatter(item) must be a function to use autocomplete directive.');
}else if(!_.exists(this.autocompleteFilter)||typeof this.autocompleteFilter!='function'){
throw new Error('controller.itemFormatter(allItems, selectedItems) must be a function to use autocomplete directive.');
}

this._$scope=$scope;
this._inputElement=$element.find('input');
this._$timeout=$timeout;
this.currentItem=null;
this.selectedItems=[];
this.search=this.search.bind(this);

$scope.$watch('controller.items',function(newItems){
_this2.updateAvailableItems();
},!0);
$scope.$watch('controller.selectedItems',function(newSelectedItems){
_this2.updateAvailableItems();
},!0);

this._inputElement.
bind('focus',function(){return _this2.showAllIfEmpty()}).
bind('keyup',function(event){
if(event.originalEvent.keyIdentifier==='Up'||event.originalEvent.keyIdentifier==='Down')
return;

_this2.showAllIfEmpty();
});

this._$timeout(function(){
_this2.updateAvailableItems();
});
}MultiValueAutocompleteController.prototype.

showAllIfEmpty=function showAllIfEmpty(){var _this3=this;
this._$timeout(function(){
if(_this3._inputElement.val().length<1){
_this3._inputElement.triggerHandler('input');
_this3._inputElement.val(SecretEmptyKey);
_this3._inputElement.triggerHandler('input');
_this3._inputElement.val('');
}else{
_this3.addItem();
}
});
};MultiValueAutocompleteController.prototype.

search=function search(item){
if(this._inputElement.val()===SecretEmptyKey){
return!0;
}

return this.itemFormatter(item).toLowerCase().indexOf(this._inputElement.val().toLowerCase())!==-1;
};MultiValueAutocompleteController.prototype.

updateAvailableItems=function updateAvailableItems(){
this.availableItems=this.autocompleteFilter(this.items,this.selectedItems);
};MultiValueAutocompleteController.prototype.

addItem=function addItem(){
if(_.includes(this.availableItems,this.currentItem)&&_.includes(this.items,this.currentItem)){
this.selectedItems.push(this.currentItem);
this.updateAvailableItems();
this.currentItem=null;
}
};return MultiValueAutocompleteController}();


module.exports=MultiValueAutocompleteDirective;
//# sourceMappingURL=multiValueAutocompleteDirective.js.map
